module.exports = __webpack_public_path__ + "static/media/christmas-event.d173de24.png";